export default "__VITE_ASSET__25bb457f__"